const visible = {
  opacity: 1,
  y: 0,
  overflowY: 'auto',
  transition: {
    staggerChildren: 0.025,
    delayChildren: 0.1,
  },
};

const hidden = {
  overflowY: 'hidden',
  opacity: 0,
  transition: {
    duration: 0.15,
    staggerChildren: 0.075,
    staggerDirection: -1,
  },
};

export const menuVariants = {
  visible: {
    ...visible,
  },
  hiddenTop: {
    y: 5,
    ...hidden,
  },

  hiddenBottom: {
    y: -5,
    ...hidden,
  },
};

export const menuItemVariants = {
  visible: {
    y: 0,
  },
  hidden: {
    y: 5,
  },
};
